const deckReducer = (state = [], action) => {
  // The deck is now a constant Master List of 54 cards.
  // We no longer remove cards from it; we filter them out based on usedCards.
  return state;
};

export default deckReducer;
